export const methodOption = [
  {
    id: "Phone-call",
    name: "student.phone_call"
  },
  {
    id: "Zalo",
    name: "student.zalo"
  },
  {
    id: "Email",
    name: "student.email"
  },
  {
    id: "Zoom-meeting",
    name: "student.zoom_meeting"
  },
  {
    id: "Face-to-face",
    name: "student.face_to_face"
  },
  {
    id: "Messenger",
    name: "student.messenger"
  },
  {
    id: "Whatsapp",
    name: "student.whatsapp"
  },
  {
    id: "Others",
    name: "student.others"
  }
];
